import { autoinject, BindingEngine, Disposable } from 'aurelia-framework';

@autoinject
export class BindingHelper {
  constructor(private be: BindingEngine) { }

  observeProperty<T>(obj: T, propertyName: Extract<keyof T, string>, callback: (newValue, oldValue) => void): Disposable {
    return this.be.propertyObserver(obj, propertyName).subscribe(callback);
  }

  observeExpression(bindingContext: unknown, expression: string, callback: (newValue, oldValue) => void) {
    return this.be.expressionObserver(bindingContext, expression).subscribe(callback);
  }

  unobserve(from: Disposable | Disposable[]): void {
    if (!Array.isArray(from)) from = [from]; from.forEach(d => d.dispose());
  }
}

export { Disposable };
